export default function Heading(props: { children: string }) {
  return (
    <p className='uppercase text-lg lg:text-xl font-black text-black mt-6 mb-4'>{props.children}</p>
  )
}
